import axios from "axios";

const requestService = axios.create({
    baseURL: "/pgcore-pos",
    timeout: 60000
});

export default requestService;